import { useEffect, useState } from "react"
import { HomeContent } from "@/components/home-content"
import type { HeroSlide, Category, Product } from "@/lib/api"
import { api } from "@/lib/api"

export default function HomePage() {
    const [heroSlides, setHeroSlides] = useState<HeroSlide[]>([])
    const [categories, setCategories] = useState<Category[]>([])
    const [featuredProducts, setFeaturedProducts] = useState<Product[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const [slides, cats, products] = await Promise.all([
                    api.getHeroSlides(),
                    api.getCategories(),
                    api.getFeaturedProducts(),
                ])

                setHeroSlides(slides || [])
                setCategories(cats || [])
                setFeaturedProducts(products || [])
            } catch (error) {
                console.log("[v0] Error fetching home page data:", error)
                setHeroSlides([])
                setCategories([])
                setFeaturedProducts([])
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        )
    }

    return <HomeContent heroSlides={heroSlides} categories={categories} featuredProducts={featuredProducts} />
}
